import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class StatesDTO {
  @ApiProperty()
  @IsOptional()
  Id?: number;
  @ApiProperty()
  @MaxLength(5, { message: "States Code allows maximum 5 characters" })
  @IsNotEmpty({message:"States Code should not be empty"})
  @IsOptional()
  stateCode: string;
  @ApiProperty()
  @MaxLength(500, { message: "States Name allows maximum 15 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"States name should be only alpha numeric" })
  stateName: string;
  @ApiProperty()
  status: boolean;
  createdAt : Date;
  @ApiProperty()
  @IsOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : number;
  @ApiProperty()
  versionFlag : number;
}

export class StateStatusDTO {
  @ApiProperty()
  @IsNotEmpty()
  Id?: number;
  @ApiProperty()
  @IsNotEmpty()
  status: boolean;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  updatedUser : number;
}

